// extracted by mini-css-extract-plugin
export var buttons = "CourseItem-module--buttons--t4hv9";
export var container = "CourseItem-module--container--+eoyp";
export var header = "CourseItem-module--header--FUngf";
export var header_free_text = "CourseItem-module--header_free_text--yTsPi";
export var header_icon = "CourseItem-module--header_icon--jnrMB";
export var info = "CourseItem-module--info--qmCPc";
export var introduction = "CourseItem-module--introduction--25jXI";
export var name = "CourseItem-module--name--P2-pJ";